/**
 * Formata a string para o padrão: 1 letra maiúscula e o resto minúscula.
 * @param {*} string string a ser formatada
 * @returns string formatada
 */
const formatString = string => string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()

export default formatString
